/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";
import { useRecoilState } from "recoil";
import { updateUser } from "../../api/User";
import { UserAtom } from "../../atoms/UserAtom";
import Switch from "../Switch";

const Contianer = styled.div`
  width: 1000px;
  height: fit-content;
  border: 1px solid #eaeaeabf;
  background-color: #ffffff;
  margin: 40px 0px;
  padding: 20px;
  cursor: default;
`;

const InfoColumn = styled.div`
  border-bottom: 1px solid #eaeaeabf;
  padding: 10px;
`;

const Title = styled.div`
  color: #222222;
  font-weight: 600;
  margin-bottom: 5px;
`;

const SubTitle = styled.div`
  color: #707070;
`;

const Label = styled.div`
  color: #333333;
  margin-right: 50px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eaeaeabf;
  padding: 20px;
`;

export default function Notifications(): JSX.Element | null {
  const [user, setUser] = useRecoilState(UserAtom);

  async function handleDesktopNotification(toggle: boolean) {
    if (!user) return false;

    const userObject = {
      ...user,
      desktopNotifications: toggle,
    };

    delete (userObject as any)._id;
    const success = await updateUser(userObject);

    if (success) {
      setUser({
        ...user,
        options: {
          ...user.options,
          desktopNotifications: toggle,
        },
      });
    }
    return false;
  }

  async function handleReceiveNewFeatures(toggle: boolean) {
    if (!user) return false;

    const userObject = {
      ...user,
      receiveNewFeatures: toggle,
    };

    delete (userObject as any)._id;
    const success = await updateUser(userObject);

    if (success) {
      setUser({
        ...user,
        options: {
          ...user.options,
          receiveNewFeatures: toggle,
        },
      });
    }
    return false;
  }

  if (!user) return null;

  return (
    <Contianer>
      <div style={{ color: "red", fontSize: "30px" }}>IN PROGRESS</div>
      <InfoColumn>
        <Title>Basics</Title>
        <SubTitle>
          Please provide the following personal information in the area below.
          These details will be used for account login and authentication.
        </SubTitle>
      </InfoColumn>

      <Row>
        <div>
          <Label>Desktop Notifications</Label>
          <SubTitle>
            Get notifications on lorem ipsum dolor sit amet consectetur.
          </SubTitle>
        </div>
        <Switch
          toggled={user.options!.desktopNotifications as boolean}
          whenToggled={(vle) => handleDesktopNotification(vle)}
        />
      </Row>

      <Row
        css={css`
          border: none;
        `}
      >
        <div>
          <Label>News</Label>
          <SubTitle>
            Email me about new features, updates and Berserker feedback surveys
          </SubTitle>
        </div>
        <Switch
          toggled={user.options!.receiveNewFeatures as boolean}
          whenToggled={(vle) => handleReceiveNewFeatures(vle)}
        />
      </Row>
    </Contianer>
  );
}
